import React from 'react'
import { PaymentMethod } from '@entities/payment'
import { SbpIcon, MtsIcon } from '@shared/assets/icons'

export const oldPaymentMethods = [
  { type: PaymentMethod.SBP, label: 'СБП', icon: <SbpIcon /> },
  { type: PaymentMethod.MTS_ACCOUNT, label: 'счёт МТС', icon: <MtsIcon /> },
]
